import * as React from 'react';
import { Component } from 'react';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import MenuItem from '@material-ui/core/MenuItem';
import { SelectValidator } from 'react-material-ui-form-validator';
import CircularProgress from '@material-ui/core/CircularProgress';
import GenderLookupViewModel from '../ViewModels/GenderLookupViewModel';

const styles = (theme: Theme) => createStyles({
    error: {
        color: "#FF0000",
    }
});

interface IGenderTypeDropDownProps {
    setGenderType?: (event) => void;
    genderType: string | undefined;
    label: string;
    disabled: boolean;
}

interface IGenderTypeDropDownState {
    model: GenderLookupViewModel[];
    loaded: boolean;
}

class GenderTypeDropDown extends Component<IGenderTypeDropDownProps & WithStyles<typeof styles>, IGenderTypeDropDownState> {
    constructor(props) {
        super(props);
        this.state = {
            model: [],
            loaded: false
        }
    }

    componentDidMount() {
        fetch('api/DropDown/GetGenderTypes').then(response => response.json()).then((data) => {
            this.setState({
                model: data,
                loaded: true,
            });
        });
    }

    public render() {
        let items: JSX.Element[] = [];

        if (this.state.model.length > 0) {
            items.push(<MenuItem key="defaultGenderTypeVal" value={undefined}></MenuItem>);
            items = this.state.model.map(item =>
                <MenuItem key={item.value} value={item.value}>{item.display}</MenuItem>
            );
        }

        return (
            <SelectValidator
                label={this.props.label}
                name="erGenderType"
                select
                fullWidth
                variant="outlined"
                margin="normal"
                value={this.props.genderType}
                onChange={this.props.disabled ? undefined : this.props.setGenderType}
                disabled={this.props.disabled}
                InputProps={{
                    disabled: !this.state.loaded,
                    startAdornment: (
                        <React.Fragment>
                            {this.state.loaded ? null : <CircularProgress size={20} />}
                        </React.Fragment>
                    ),
                    readOnly: this.props.disabled
                }}
            >
                {items}
            </SelectValidator>
        );
    }
}

export default withStyles(styles)(GenderTypeDropDown);
